import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie';
import ajax from '../utils/request.js';
import TRTCCalling from 'trtc-calling-js';

Vue.use(Router)
import Layout from '@/layout';

export const constantRoutes = [{
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login'),
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('@/views/error-page/error'),
  },
  {
    path: '/',
    component: Layout,
    children: [{
      path: '/',
      name: 'home',
      component: () => import('@/views/home/home'),
      meta: {
        title: '问诊室'
      }
    }]
  },
  {
    path: '/orderList',
    component: Layout,
    children: [{
      path: '/orderList',
      name: 'orderList',
      component: () => import('@/views/orderList/orderList'),
      meta: {
        title: '问诊记录'
      }
    }]
  },
]

const createRouter = () => new Router({
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRoutes
});
const router = createRouter();
router.beforeEach((to, from, next) => {
  //   Vue.prototype.TRTC.getCameras().then(Cameras => {
  //     console.log(Cameras);
  //     if (Cameras.length > 0) {
  if (to.path === '/login') {
    next();
  } else if (Cookies.get('doctortoken') === undefined && Cookies.get('rk_token') === undefined) {
    router.push({
      name: "login",
    })
  } else if (Cookies.get('UserID') ) {
    // ajax.get(Vue.prototype.$api + '/get_user_sig', {
    //     userid: Cookies.get('UserID')
    //   })
    //   .then((res) => {
    //     let options = {
    //       SDKAppID: parseInt(window.localStorage.getItem('sdkappid'))
    //     };
        //Vue.prototype.$trtcCalling = new TRTCCalling(options)
        //Vue.prototype.$trtcCalling.login({
           // userID: Cookies.get('UserID'),
            //userSig: res
          //})
          //.then(() => {
            next();
          //})
      //})
  } else {
    router.push({
      name: "login",
    })
  }
  //     } else {
  //       alert('没有可用摄像头，请手动刷新页面');
  //     }
  //   })
});
/*router.beforeEach((to, from, next) => {
    if (to.path === '/login' || to.path === "/error") {
        next();
    } else if (Cookies.get('logo') === undefined) {
        ajax.get(Vue.prototype.$api + '/auth_path.do', {
            "to_path": to.path
        })
            .then((res) => {
                if (res.code === 0) {
                    Cookies.set('logo', res.data.logo);
                    Cookies.set('baseuserid', res.data.baseuserid);
                    router.push({
                        name: "login",
                    })
                } else {
                    router.push({
                        name: "error"
                    })
                }
            });
    } else if (Cookies.get('doctortoken') === undefined && Cookies.get('rk_token') === undefined) {
        ajax.get(Vue.prototype.$api + '/auth_path.do', {
            "to_path": to.path
        })
            .then((res) => {
                if (res.code === 0) {
                    Cookies.set('logo', res.data.logo);
                    Cookies.set('baseuserid', res.data.baseuserid);
                    router.push({
                        name: "login",
                    })
                } else {
                    router.push({
                        name: "error"
                    })
                }
            });
    } else {
        var paths = ['/rk']
        for (var i in paths) {
            if (paths[i] === to.path) {
                Cookies.remove('wx_name');
                Cookies.remove('doctortoken');
                Cookies.remove('rk_token');
                Cookies.remove('role_id');
                Cookies.remove('headimg');
                Cookies.remove('UserID');
                window.localStorage.removeItem('router')
                ajax.get(Vue.prototype.$api + '/auth_path.do', {
                    "to_path": to.path
                })
                    .then((res) => {
                        if (res.code === 0) {
                            Cookies.set('logo', res.data.logo);
                            Cookies.set('baseuserid', res.data.baseuserid);
                            router.push({
                                name: "login",
                            })
                        } else {
                            router.push({
                                name: "error"
                            })
                        }
                    });
            } else {
                if (Cookies.get('UserID')) {
                    ajax.get(Vue.prototype.$api + '/get_user_sig', { userid: Cookies.get('UserID') })
                        .then((res) => {
                            Vue.prototype.$trtcCalling.login({ userID: Cookies.get('UserID'), userSig: res })
                                .then(() => {
                                    next();
                                })
                        })
                }
            }
        }
    }
});*/

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js